export class UserAccountExpiredException extends Error {
  constructor(message) {
    super(message);
  }
}

